(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8552],{

/***/ 27638:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(70526);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ AboutUsFeature; }
});

// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/@cinch-labs/design-system/dist/index.esm.js
var index_esm = __webpack_require__(55370);
// EXTERNAL MODULE: ../../../libs/data/storyblok/src/index.ts + 18 modules
var src = __webpack_require__(60782);
// EXTERNAL MODULE: ../../../libs/landing/ui/shared/src/index.ts + 295 modules
var shared_src = __webpack_require__(88805);
// EXTERNAL MODULE: ../../../libs/shared/ui/src/index.ts + 120 modules
var ui_src = __webpack_require__(99313);
// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/about-us.module.css
var about_us_module = __webpack_require__(17018);
var about_us_module_default = /*#__PURE__*/__webpack_require__.n(about_us_module);
// EXTERNAL MODULE: ../../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(19601);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/components/careers/careers.module.css
var careers_module = __webpack_require__(10644);
var careers_module_default = /*#__PURE__*/__webpack_require__.n(careers_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/careers/careers.tsx




const CareersSection = (blok)=>{
    const { heading , body , image  } = blok;
    const [CTA] = (blok === null || blok === void 0 ? void 0 : blok.CTA) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (careers_module_default()).wrapper,
        children: [
            (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (careers_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.filename,
                    alt: image.alt ?? undefined,
                    layout: "fill",
                    objectFit: "cover"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (careers_module_default()).textWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                        className: (careers_module_default()).heading,
                        children: heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        className: (careers_module_default()).body,
                        children: body
                    }),
                    CTA ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                        element: "a",
                        href: CTA.url,
                        classNames: {
                            button: (careers_module_default()).button
                        },
                        children: CTA.text
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var careers = (CareersSection);

// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/components/constellation/constellation.module.css
var constellation_module = __webpack_require__(42163);
var constellation_module_default = /*#__PURE__*/__webpack_require__.n(constellation_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/constellation/constellation.tsx




const ConstellationSection = (blok)=>{
    const { body , image  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (constellation_module_default()).wrapper,
        children: [
            (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (constellation_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.filename,
                    alt: image.alt ?? undefined,
                    layout: "fill"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (constellation_module_default()).body,
                children: body
            })
        ]
    });
};
/* harmony default export */ var constellation = (ConstellationSection);

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/components/delivery-collect/delivery-collect.module.css
var delivery_collect_module = __webpack_require__(4346);
var delivery_collect_module_default = /*#__PURE__*/__webpack_require__.n(delivery_collect_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/delivery-collect/option-card.tsx







const DeliveryOptionCard = (blok)=>{
    const { _uid , heading , body , image  } = blok;
    const [CTA] = (blok === null || blok === void 0 ? void 0 : blok.CTA) || [];
    return /*#__PURE__*/ (0,react.createElement)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        key: _uid,
        children: [
            (image === null || image === void 0 ? void 0 : image.filename) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (delivery_collect_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.filename,
                    alt: image.alt ?? undefined,
                    layout: "fill",
                    objectFit: "cover"
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                element: "h3",
                className: (delivery_collect_module_default()).optionHeading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (delivery_collect_module_default()).optionBody,
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                ...(0,src/* storyblokEditable */.LF)(CTA),
                element: "a",
                href: CTA.url,
                classNames: {
                    button: (delivery_collect_module_default()).optionButton
                },
                children: CTA.text
            })
        ]
    });
};
/* harmony default export */ var option_card = (DeliveryOptionCard);

;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/delivery-collect/delivery-collect.tsx






const DeliveryCollectSection = (blok)=>{
    const { heading , body , options  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        className: (delivery_collect_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (delivery_collect_module_default()).heading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (delivery_collect_module_default()).body,
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (delivery_collect_module_default()).options,
                children: options === null || options === void 0 ? void 0 : options.map((option)=>/*#__PURE__*/ (0,react.createElement)(option_card, {
                        ...option,
                        key: option._uid
                    }))
            })
        ]
    });
};
/* harmony default export */ var delivery_collect = (DeliveryCollectSection);

// EXTERNAL MODULE: ../../../node_modules/classnames/index.js
var classnames = __webpack_require__(95685);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/components/image-gallery/image-gallery.module.css
var image_gallery_module = __webpack_require__(82225);
var image_gallery_module_default = /*#__PURE__*/__webpack_require__.n(image_gallery_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/image-gallery/image-gallery.tsx





const ImageGallery = (blok)=>{
    var ref;
    const { images  } = blok;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        className: (image_gallery_module_default()).galleryGrid,
        children: (ref = images === null || images === void 0 ? void 0 : images.filter((image)=>{
            return image === null || image === void 0 ? void 0 : image.filename;
        })) === null || ref === void 0 ? void 0 : ref.map((image, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((image_gallery_module_default()).imageWrapper, (image_gallery_module_default())[`image${idx + 1}`], {
                    [(image_gallery_module_default()).mobileMargins]: idx <= 1,
                    [(image_gallery_module_default()).mobileImage]: idx <= 2,
                    [(image_gallery_module_default()).desktopImage]: idx > 2
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image.filename,
                    alt: image.alt ?? undefined,
                    layout: "fill",
                    objectPosition: "60% center",
                    objectFit: "cover"
                })
            }, image.id))
    });
};
/* harmony default export */ var image_gallery = (ImageGallery);

;// CONCATENATED MODULE: ../../../node_modules/@react-hook/media-query/dist/module/index.js


function queriesDidChange(prevQueries, nextQueries) {
  if (nextQueries === prevQueries) return false;
  const nextQueriesArr = Object.values(nextQueries);
  const prevQueriesArr = Object.values(prevQueries);
  if (nextQueriesArr.length !== prevQueriesArr.length) return true;
  if (nextQueriesArr.some((q, i) => q !== prevQueriesArr[i])) return true;
  const prevKeys = Object.keys(prevQueries);
  return Object.keys(nextQueries).some((n, i) => n !== prevKeys[i]);
}

function _ref(curr, key) {
  curr.matches[key] = false;
  curr.mediaQueries[key] = {};
  return curr;
}

function init(queries) {
  const queryKeys = Object.keys(queries);
  /* istanbul ignore next */

  if (typeof window === 'undefined') return queryKeys.reduce(_ref, {
    mediaQueries: {},
    matches: {}
  });
  return queryKeys.reduce((state, name) => {
    const mql = window.matchMedia(queries[name]);
    state.mediaQueries[name] = mql;
    state.matches[name] = mql.matches;
    return state;
  }, {
    mediaQueries: {},
    matches: {}
  });
}

function reducer(state, action) {
  function _ref2(prev, key) {
    prev[key] = state.mediaQueries[key].matches;
    return prev;
  }

  switch (action.type) {
    case 'updateMatches':
      return {
        matches: Object.keys(state.mediaQueries).reduce(_ref2, {}),
        mediaQueries: state.mediaQueries
      };

    case 'setQueries':
      return init(action.queries);
  }
}
/**
 * A hook that returns a [`MediaQueryMatches`](#mediaquerymatches) object which will
 * tell you if specific media queries matched, all media queries matched, or
 * any media queries matched. Matches in this hook will always return `false` when
 * rendering on the server.
 *
 * @param queryMap The media queries you want to match against e.g. `{screen: "screen", width: "(min-width: 12em)"}`
 */


function useMediaQueries(queryMap) {
  const prevQueries = react.useRef(queryMap);
  const [state, dispatch] = react.useReducer(reducer, queryMap, init);
  react.useEffect(() => {
    if (queriesDidChange(queryMap, prevQueries.current)) {
      dispatch({
        type: 'setQueries',
        queries: queryMap
      });
      prevQueries.current = queryMap;
    }
  }, [queryMap]);

  function _ref3() {
    return dispatch({
      type: 'updateMatches'
    });
  }

  function _ref4(mq) {
    const callback = _ref3;
    if (typeof mq.addListener !== 'undefined') mq.addListener(callback);else mq.addEventListener('change', callback);
    return callback;
  }

  react.useEffect(() => {
    const queries = Object.values(state.mediaQueries);
    const callbacks = queries.map(_ref4);

    function _ref5(mq, i) {
      if (typeof mq.addListener !== 'undefined') mq.removeListener(callbacks[i]);else mq.removeEventListener('change', callbacks[i]);
    }

    return () => {
      queries.forEach(_ref5);
    };
  }, [state.mediaQueries]);
  const {
    matches
  } = state;
  const matchValues = react.useMemo(() => Object.values(matches), [matches]);
  return {
    matches,
    matchesAny: matchValues.some(Boolean),
    matchesAll: matchValues.length > 0 && matchValues.every(Boolean)
  };
}
/**
 * A hook that returns `true` if the media query matched and `false` if not. This
 * hook will always return `false` when rendering on the server.
 *
 * @param query The media query you want to match against e.g. `"only screen and (min-width: 12em)"`
 */

function useMediaQuery(query) {
  return useMediaQueries(getObj(query)).matchesAll;
}
const cache = {};

function getObj(query) {
  if (cache[query] === void 0) cache[query] = {
    default: query
  };
  return cache[query];
}
// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/components/partnerships/partnerships.module.css
var partnerships_module = __webpack_require__(77155);
var partnerships_module_default = /*#__PURE__*/__webpack_require__.n(partnerships_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/partnerships/partnerships.tsx






const Partnerships = (blok)=>{
    var ref;
    const { heading , body , partners  } = blok;
    const [CTA] = blok.CTA || [];
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const carouselSettings = {
        name: "about-us-partnerships",
        ariaLabels: {
            previous: "Go to previous slide",
            next: "Go to next slide"
        },
        swiperSettings: {
            spaceBetween: 78,
            slidesPerView: isDesktop ? 3 : 1
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ...(0,src/* storyblokEditable */.LF)(blok),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (partnerships_module_default()).heading,
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (partnerships_module_default()).body,
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Carousel */.lr, {
                name: carouselSettings.name,
                swiperSettings: carouselSettings.swiperSettings,
                customClassNames: {
                    carousel: (partnerships_module_default()).carousel
                },
                children: (ref = partners === null || partners === void 0 ? void 0 : partners.filter((image)=>{
                    return image === null || image === void 0 ? void 0 : image.filename;
                })) === null || ref === void 0 ? void 0 : ref.map((image)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (partnerships_module_default()).imageWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: image.filename,
                                alt: image.alt ?? undefined,
                                className: (partnerships_module_default()).image
                            })
                        })
                    }, image.id))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui_src/* CarouselControls */.J8, {
                customClassNames: (partnerships_module_default()).carouselControls,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselPagination */.Jj, {
                        name: carouselSettings.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* CarouselNavigation */.Pn, {
                        name: carouselSettings.name,
                        ariaLabels: carouselSettings.ariaLabels,
                        customClassNames: {
                            prevButton: (partnerships_module_default()).carouselNavButton,
                            nextButton: (partnerships_module_default()).carouselNavButton
                        }
                    })
                ]
            }),
            CTA ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ...(0,src/* storyblokEditable */.LF)(CTA),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (partnerships_module_default()).buttonWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Secondary */.T7, {
                        element: "a",
                        href: CTA.url,
                        classNames: {
                            button: (partnerships_module_default()).button
                        },
                        children: CTA.text
                    })
                })
            }) : null
        ]
    });
};
/* harmony default export */ var partnerships = (Partnerships);

// EXTERNAL MODULE: ../../../libs/landing/feature-about-us/src/lib/components/get-in-touch/get-in-touch.module.css
var get_in_touch_module = __webpack_require__(6364);
var get_in_touch_module_default = /*#__PURE__*/__webpack_require__.n(get_in_touch_module);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/get-in-touch/get-in-touch.tsx



const GetInTouch = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (get_in_touch_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                className: (get_in_touch_module_default()).title,
                children: "Need to get in touch?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                className: (get_in_touch_module_default()).body,
                children: "Call, email or WhatsApp, we’re here to help."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (get_in_touch_module_default()).cardGroup,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (get_in_touch_module_default()).card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                name: "mail"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                element: "h3",
                                className: (get_in_touch_module_default()).cardHeading,
                                children: "Customer Support"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                                href: "mailto:hello@cinch.co.uk",
                                target: "_blank",
                                rel: "noreferrer",
                                hasNoLine: true,
                                children: "hello@cinch.co.uk"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                                href: "tel:+443330154101",
                                target: "_blank",
                                rel: "noreferrer",
                                hasNoLine: true,
                                children: "0333 015 4101"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* TextLink */.hh, {
                                href: "https://wa.me/447831910589",
                                target: "_blank",
                                rel: "noreferrer",
                                hasNoLine: true,
                                children: "WhatsApp"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (get_in_touch_module_default()).card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* SvgIcon */.le, {
                                name: "edit"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                                element: "h3",
                                className: (get_in_touch_module_default()).cardHeading,
                                children: "Write to us"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Text */.xv, {
                                children: [
                                    "Cinch Cars Limited",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " Form 2, 18 Bartley Wood",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " Business Park, Bartley Way,",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " Hook, Hampshire RG27 9XA"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
/* harmony default export */ var get_in_touch = (GetInTouch);

;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/components/index.ts







;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/data/storyblok-renderer-map.ts




const storyblokComponents = {
    GenericTeaser: shared_src/* GenericTeaser */.qg,
    StatsSection: shared_src/* StatsSection */.No,
    GenericQuote: shared_src/* TrustPilotQuote */.DP,
    AboutUsCareers: careers,
    AboutUsConstellation: constellation,
    AboutUsDeliverySection: delivery_collect,
    AboutUsImageGallery: image_gallery,
    AboutUsPartnershipSection: partnerships
};

;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/about-us.tsx








function AboutUsFeature({ story , carTotal , generatedAt , preview  }) {
    var ref, ref1;
    const { content  } = (0,src/* useStoryblokState */.f0)({
        story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* Head */.Fb, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "About Us - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (about_us_module_default()).root,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (about_us_module_default()).teaserContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (about_us_module_default()).teaserContainerInner,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                                block: content.Teaser,
                                components: storyblokComponents
                            })
                        })
                    }),
                    ((ref1 = content.Video) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        className: {
                            inner: (about_us_module_default()).videoContainer
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Youtube */.hx, {
                            videoId: content.Video[0].videoId,
                            title: content.Video[0].title,
                            buttonLabel: content.Video[0].buttonLabel,
                            className: (about_us_module_default()).video,
                            customThumbnail: content.Video[0].thumbnail.filename,
                            videoUrlOptions: {
                                autoplay: 1
                            },
                            showNewPlayIcon: true
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        className: {
                            container: (about_us_module_default()).quoteSection
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.TrustPilotQuoteV2,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (about_us_module_default()).statsSection
                        },
                        isFluid: true,
                        backgroundColor: "#ECF5FA",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.Stats,
                            components: storyblokComponents,
                            props: {
                                carTotal,
                                trackingEventName: "About us - Browse all car clicks"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.Delivery,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        backgroundColor: "#F5F5F5",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                            className: {
                                container: (about_us_module_default()).partnershipsContainer,
                                inner: (about_us_module_default()).partnershipsContainerInner
                            },
                            isSlim: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                                block: content.Partnerships,
                                components: storyblokComponents
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        className: {
                            container: (about_us_module_default()).careersContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                            block: content.Careers,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        backgroundColor: "#F2F5FF",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                            className: {
                                container: (about_us_module_default()).constellationContainer,
                                inner: (about_us_module_default()).constellationContainerInner
                            },
                            isSlim: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_src/* StoryblokRenderer */.kv, {
                                block: content.Constellation,
                                components: storyblokComponents
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_src/* Wrapper */.im, {
                        isSlim: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(get_in_touch, {})
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../../libs/shared/environments/src/index.ts + 5 modules
var environments_src = __webpack_require__(48114);
// EXTERNAL MODULE: ../../../libs/core/datadog-server/src/index.ts + 7 modules
var datadog_server_src = __webpack_require__(86634);
;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/lib/get-static-props.ts



const VEHICLE_SEARCH_URL = `${(0,environments_src/* readFromEnv */.u)(environments_src/* Env.SearchServiceUrl */.X.SearchServiceUrl)}/vehicles`;
async function getStaticPropsfn({ preview =false  }) {
    var ref, ref1;
    const story = await (0,src/* getStoryBySlug */.OI)("about-us", {
        version: preview ? "draft" : "published"
    });
    if (!story) {
        (0,datadog_server_src/* setTag */.YA)("page.response-code", "500");
        throw new Error("Unable to fetch `about-us` story from storyblok");
    }
    const HeroProps = (ref = story.content) === null || ref === void 0 ? void 0 : (ref1 = ref.Hero) === null || ref1 === void 0 ? void 0 : ref1[0];
    const carTotal = await fetch(VEHICLE_SEARCH_URL).then((response)=>response.json()).then((data)=>data.searchResultsCount).catch((error)=>{
        if (error instanceof Error || typeof error === "string") {
            (0,datadog_server_src/* tagError */.$k)(error);
        }
        return 0;
    });
    (0,datadog_server_src/* setTag */.YA)("response.code", 200);
    (0,datadog_server_src/* setTag */.YA)("page.rendered", "ISR");
    (0,datadog_server_src/* setTag */.YA)("page.revalidate-in", "300s");
    (0,datadog_server_src/* setTag */.YA)("page.name", "about-us");
    (0,datadog_server_src/* setTag */.YA)("page.params", JSON.stringify({
        preview,
        carTotal
    }, null, 2));
    (0,datadog_server_src/* setTag */.YA)("page.response-code", "200");
    return {
        props: {
            story,
            preview,
            generatedAt: Date.now(),
            layoutProps: {
                heroProps: HeroProps,
                showBorderRadius: true
            },
            carTotal
        },
        revalidate: 300
    };
}
const getStaticProps = (0,datadog_server_src/* traceFunction */.KG)("about-us.getStaticProps", getStaticPropsfn);

;// CONCATENATED MODULE: ../../../libs/landing/feature-about-us/src/index.ts



;// CONCATENATED MODULE: ./pages/about-us.tsx
var __N_SSG = true;



/***/ }),

/***/ 17018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"about-us_root__RKn_s","teaserContainer":"about-us_teaserContainer__qIQUj","teaserContainerInner":"about-us_teaserContainerInner__A2NvZ","quoteSection":"about-us_quoteSection__u0yP_","careersContainer":"about-us_careersContainer__0H_QE","constellationContainer":"about-us_constellationContainer__xGjNw","constellationContainerInner":"about-us_constellationContainerInner__s3inT","partnershipsContainerInner":"about-us_partnershipsContainerInner__tSBXO","partnershipsContainer":"about-us_partnershipsContainer__eEDqD","statsSection":"about-us_statsSection__rtkmN","videoContainer":"about-us_videoContainer__FkiBa","video":"about-us_video__4OYbt"};

/***/ }),

/***/ 10644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"careers_wrapper__S48up","textWrapper":"careers_textWrapper__O6L68","imageWrapper":"careers_imageWrapper__HVKo9","heading":"careers_heading__LGjF_","body":"careers_body__K3fYx","button":"careers_button__J114K"};

/***/ }),

/***/ 42163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"constellation_wrapper___hmDF","body":"constellation_body__0ISMC","imageWrapper":"constellation_imageWrapper__y1nQn"};

/***/ }),

/***/ 4346:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"delivery-collect_wrapper__gq2_L","heading":"delivery-collect_heading__E_8f6","body":"delivery-collect_body__0D5hI","options":"delivery-collect_options__jvCZg","imageWrapper":"delivery-collect_imageWrapper__k_UJN","optionHeading":"delivery-collect_optionHeading__CNa18","optionBody":"delivery-collect_optionBody__e2h_A","optionButton":"delivery-collect_optionButton__RvQkO"};

/***/ }),

/***/ 6364:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"get-in-touch_container__QdOa9","title":"get-in-touch_title__hTzwX","body":"get-in-touch_body__1fR2H","cardGroup":"get-in-touch_cardGroup__KX9vF","card":"get-in-touch_card__wW6Rk","cardHeading":"get-in-touch_cardHeading__2eC2o"};

/***/ }),

/***/ 82225:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"galleryGrid":"image-gallery_galleryGrid__GEMBD","imageWrapper":"image-gallery_imageWrapper__cUVFe","mobileMargins":"image-gallery_mobileMargins__uzcnI","mobileImage":"image-gallery_mobileImage__I8l1H","desktopImage":"image-gallery_desktopImage__Yu9Be","image1":"image-gallery_image1__YFmL0","image2":"image-gallery_image2__dQAsU","image3":"image-gallery_image3__WAipZ","image4":"image-gallery_image4__vwTbE","image5":"image-gallery_image5__XdCcK","image6":"image-gallery_image6__kA7Si"};

/***/ }),

/***/ 77155:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"partnerships_heading__J3QJ9","body":"partnerships_body__8R6Vj","carousel":"partnerships_carousel__DVLc4","carouselControls":"partnerships_carouselControls__U3V0Q","carouselNavButton":"partnerships_carouselNavButton__mUKuT","carouselPips":"partnerships_carouselPips__t0MI_","buttonWrapper":"partnerships_buttonWrapper__F3Ltd","button":"partnerships_button__yZXk_","imageWrapper":"partnerships_imageWrapper__f8ynq","image":"partnerships_image__t4V0D"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(27638); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);